import React, { useContext } from "react";

import { Context } from "../../provider/index.js"

import "../../styles/screens/general.scss";

const Footer = ({ children, noArrow = false, actives = [1,1,1,1] }) => {
  const { admin } = useContext(Context);

  if (children) {
    return (
      <div className="uiFooter">{ children }</div>
    );
  }

  if (noArrow) {
    return (<div className="uiFooter"/>)
  }

  return (
    <div className="uiFooter">
      <div className="buttons">
        <div className={`btn ${actives[0] == 0 ? 'disable' : ''} ${admin.activeButton == "up" ? 'active' : ''}`}>
          <img src="./images/buttons/arrowUp.png" alt="arrowUp"></img>
        </div>
        <div className="buttonRow">
          <div className={`btn ${actives[3] == 0 ? 'disable' : ''} ${admin.activeButton == "left" ? 'active' : ''}`}>
            <img src="./images/buttons/arrowLeft.png" alt="arrowLeft"></img>
          </div>
          <div className={`btn ${actives[2] == 0 ? 'disable' : ''} ${admin.activeButton == "down" ? 'active' : ''}`}>
            <img src="./images/buttons/arrowDown.png" alt="arrowDown"></img>
          </div>
          <div className={`btn ${actives[1] == 0 ? 'disable' : ''} ${admin.activeButton == "right" ? 'active' : ''}`}>
            <img src="./images/buttons/arrowRight.png" alt="arrowRigth"></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
